import { render, staticRenderFns } from "./McnDeptSelect.vue?vue&type=template&id=2e2dc72b&scoped=true"
import script from "./McnDeptSelect.vue?vue&type=script&lang=js"
export * from "./McnDeptSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2dc72b",
  null
  
)

export default component.exports